/* ***************************************************************************
------------------------------ Focus/Blur Input ------------------------------
*************************************************************************** */
(function($){
    // SELECT2
	if ($(".select2-js").length) {
		$(".select2-js").select2({
			minimumResultsForSearch: Infinity,
			dropdownAutoWidth: true,
			width: '100%'
		});
	}
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/select2.js